
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hqnQO", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $e5eced0f7f5acf84$var$styles = {
    selfMentionWrapper: "_0bjKvDKxmn _3vBAKHjOvk _2OUyjtGk8v _1UtDYze5R3",
    mentionWrapper: "_0bjKvDKxmn _3vBAKHjOvk"
};
const $e5eced0f7f5acf84$export$4c646efe5cd4ee34 = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { name: name, isUserSelf: isUserSelf } = t0;
    let t1;
    if ($[0] !== isUserSelf || $[1] !== name) {
        t1 = isUserSelf ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            as: "span",
            backgroundColor: "color.background.brand.bold",
            padding: "space.025",
            xcss: $e5eced0f7f5acf84$var$styles.selfMentionWrapper
        }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            as: "span",
            backgroundColor: "color.background.neutral",
            padding: "space.025",
            testId: "mention-component",
            xcss: $e5eced0f7f5acf84$var$styles.mentionWrapper
        }, name);
        $[0] = isUserSelf;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["MentionComponent"] = $e5eced0f7f5acf84$export$4c646efe5cd4ee34;

});


//# sourceMappingURL=MentionComponent.ba189a1c.js.map
